import { Survey } from 'api-models'
import { ApiClient } from '../api-client'

export type SurveyInput = Omit<Survey, 'id' | 'created_at' | 'updated_at' | 'created_by'>

const list = async (): Promise<Survey[]> => {
	const { data } = await ApiClient.client.get('/admin/surveys')
	return data.data
}

const getById = async (id: string): Promise<Survey> => {
	const { data } = await ApiClient.client.get(`/admin/surveys/${id}`)
	return data.data
}

const create = async (payload: SurveyInput): Promise<Survey> => {
	const { data } = await ApiClient.client.post('/admin/surveys', payload)
	return data.data
}

const update = async (id: string, payload: Partial<SurveyInput>): Promise<Survey> => {
	const { data } = await ApiClient.client.patch(`/admin/surveys/${id}`, payload)
	return data.data
}

const remove = async (id: string): Promise<void> => {
	await ApiClient.client.delete(`/admin/surveys/${id}`)
}

export const AdminSurveys = {
	list,
	getById,
	create,
	update,
	remove
}
